import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import { Button, Modal } from 'react-bootstrap';
import ProjectIndexListGroup from '../ProjectIndexListGroup';
import ProjectIndexRow from '../ProjectIndexRow';
import { putRequest, getRequest } from '../../requestUtils';
export var buildProjectState = function buildProjectState() {
  var projects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var projectStages = ['employer_draft', 'employer_requested_matching', 'clora_matching', 'clora_matched', 'executed_agreement', 'work_started', 'work_completed', 'on_hold', 'closed'];
  var customKeyMap = {
    clora_matched: 'matched' // custom override
  };
  var merged = {};
  var updatedKeys = [];
  projectStages.forEach(function (key) {
    var camelCaseKey = customKeyMap[key] || key.replace(/_([a-z])/g, function (_, letter) {
      return letter.toUpperCase();
    });
    var newData = projects[key];
    if (Array.isArray(newData) && newData.length > 0) {
      merged[camelCaseKey] = newData;
      updatedKeys.push(camelCaseKey);
    } else if (currentState[camelCaseKey]) {
      merged[camelCaseKey] = currentState[camelCaseKey];
    } else {
      merged[camelCaseKey] = [];
    }
  });
  return {
    merged: merged,
    updatedKeys: updatedKeys
  };
};
var ProjectIndexContainer = /*#__PURE__*/function (_Component) {
  function ProjectIndexContainer(props) {
    var _this;
    _classCallCheck(this, ProjectIndexContainer);
    _this = _callSuper(this, ProjectIndexContainer, [props]);
    _this.state = _objectSpread(_objectSpread({}, buildProjectState(props.projects).merged), {}, {
      errors: [],
      showModal: false,
      isFetchingKey: '',
      isFetching: false
    });
    _this.beginMatching = _this.beginMatching.bind(_this);
    _this.requestMatching = _this.requestMatching.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.setCurrentActiveKey = _this.setCurrentActiveKey.bind(_this);
    return _this;
  }
  _inherits(ProjectIndexContainer, _Component);
  return _createClass(ProjectIndexContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var params = new URLSearchParams(window.location.search);
      var status = params.get('status');
      this.setState({
        defaultStatus: status || 'clora_matching'
      });
    }
  }, {
    key: "beginMatching",
    value: function beginMatching(event) {
      var _this2 = this;
      var csrfToken = this.props.csrfToken;
      var _this$state = this.state,
        employerRequestedMatching = _this$state.employerRequestedMatching,
        cloraMatching = _this$state.cloraMatching;
      var index = event.target.value;
      var project = employerRequestedMatching[index];
      var newEmployerRequestedMatching = _toConsumableArray(employerRequestedMatching);
      newEmployerRequestedMatching.splice(index, 1);
      return putRequest("/projects/".concat(project.resource_id, "/begin_clora_matching"), {}, csrfToken).then(function (response) {
        _this2.setState({
          employerRequestedMatching: newEmployerRequestedMatching,
          cloraMatching: [].concat(_toConsumableArray(cloraMatching), [response.data])
        });
      })["catch"](function (err) {
        _this2.setState({
          errors: err,
          showModal: true
        });
      });
    }
  }, {
    key: "requestMatching",
    value: function requestMatching(event) {
      var _this3 = this;
      var csrfToken = this.props.csrfToken;
      var _this$state2 = this.state,
        employerRequestedMatching = _this$state2.employerRequestedMatching,
        employerDraft = _this$state2.employerDraft;
      var index = event.target.value;
      var project = employerDraft[index];
      var newEmployerDraft = _toConsumableArray(employerDraft);
      newEmployerDraft.splice(index, 1);
      return putRequest("/projects/".concat(project.resource_id, "/publish"), {}, csrfToken).then(function (response) {
        _this3.setState({
          employerDraft: newEmployerDraft,
          employerRequestedMatching: [].concat(_toConsumableArray(employerRequestedMatching), [response.data])
        });
      })["catch"](function (err) {
        _this3.setState({
          errors: err,
          showModal: true
        });
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "renderGroup",
    value: function renderGroup(projects, callback) {
      var showEmploymentType = this.props.showEmploymentType;
      return projects.map(function (project, index) {
        return /*#__PURE__*/React.createElement("li", {
          className: "list-group-item",
          key: project.resource_id
        }, /*#__PURE__*/React.createElement(ProjectIndexRow, {
          name: project.name,
          projectLink: project.project_link,
          owner: project.owner,
          ownerLink: project.owner_link,
          company: project.company,
          companyLink: project.company_link,
          timestamp: project.timestamp,
          daysOpen: project.days_opened,
          status: project.status,
          numProposals: project.num_proposals,
          firstProposalSubmittedAt: project.first_proposal_timestamp,
          numInterests: project.pending_interest_count,
          mostRecentInterestTimestamp: project.most_recent_interest_timestamp,
          editable: project.editable,
          editLink: project.edit_link,
          specialFieldsLink: project.special_fields_link,
          isPublic: project.is_public,
          type: project.project_type,
          index: index,
          assignedRep: project.assigned_rep,
          callback: callback,
          employmentType: project.employment_type,
          showEmploymentType: showEmploymentType
        }));
      });
    }
  }, {
    key: "setCurrentActiveKey",
    value: function setCurrentActiveKey(eventKey) {
      var _this$state$stateKey,
        _this4 = this;
      var customKeyMap = {
        clora_matched: 'matched'
      };
      var stateKey = customKeyMap[eventKey] || eventKey.replace(/_([a-z])/g, function (_, letter) {
        return letter.toUpperCase();
      });
      if ((_this$state$stateKey = this.state[stateKey]) !== null && _this$state$stateKey !== void 0 && _this$state$stateKey.length) {
        this.setState(function (prevState) {
          return {
            defaultStatus: prevState.defaultStatus === eventKey ? '' : eventKey
          };
        });
        return;
      }
      this.setState(function (prevState) {
        return {
          isFetchingKey: prevState.isFetchingKey === eventKey ? '' : eventKey,
          isFetching: true
        };
      });
      getRequest("/projects?status=".concat(eventKey), {}, this.props.csrfToken).then(function (response) {
        _this4.setState(function (prevState) {
          var _buildProjectState = buildProjectState(response.data, prevState),
            merged = _buildProjectState.merged,
            updatedKeys = _buildProjectState.updatedKeys;
          return _objectSpread(_objectSpread(_objectSpread({}, prevState), merged), {}, {
            defaultStatus: prevState.defaultStatus === eventKey ? '' : eventKey,
            isFetching: false
          });
        });
      })["catch"](function (err) {
        _this4.setState({
          errors: err,
          showModal: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
        employerDraft = _this$state3.employerDraft,
        employerRequestedMatching = _this$state3.employerRequestedMatching,
        cloraMatching = _this$state3.cloraMatching,
        matched = _this$state3.matched,
        executedAgreement = _this$state3.executedAgreement,
        workStarted = _this$state3.workStarted,
        workCompleted = _this$state3.workCompleted,
        onHold = _this$state3.onHold,
        closed = _this$state3.closed,
        errors = _this$state3.errors,
        defaultStatus = _this$state3.defaultStatus,
        isFetching = _this$state3.isFetching,
        isFetchingKey = _this$state3.isFetchingKey;
      return /*#__PURE__*/React.createElement(Accordion, {
        defaultActiveKey: defaultStatus,
        activeKey: defaultStatus
      }, /*#__PURE__*/React.createElement(ProjectIndexListGroup, {
        count: cloraMatching.length,
        classes: "bg-info",
        status: "clora_matching",
        title: "Clora Matching",
        showLoading: isFetching,
        setCurrentActiveKey: this.setCurrentActiveKey
      }, this.renderGroup(cloraMatching)), /*#__PURE__*/React.createElement(ProjectIndexListGroup, {
        count: employerRequestedMatching.length,
        classes: "bg-primary",
        status: "employer_requested_matching",
        title: "Employer Requested Matching",
        isFetching: isFetching,
        isFetchingKey: isFetchingKey,
        setCurrentActiveKey: this.setCurrentActiveKey
      }, this.renderGroup(employerRequestedMatching, this.beginMatching)), /*#__PURE__*/React.createElement(ProjectIndexListGroup, {
        count: employerDraft.length,
        classes: "bg-default",
        status: "employer_draft",
        title: "Employer Draft",
        callback: this.requestMatching,
        isFetching: isFetching,
        isFetchingKey: isFetchingKey,
        setCurrentActiveKey: this.setCurrentActiveKey
      }, this.renderGroup(employerDraft, this.requestMatching)), /*#__PURE__*/React.createElement(ProjectIndexListGroup, {
        count: matched.length,
        classes: "bg-success",
        status: "clora_matched",
        title: "Matched",
        isFetching: isFetching,
        isFetchingKey: isFetchingKey,
        setCurrentActiveKey: this.setCurrentActiveKey
      }, this.renderGroup(matched)), /*#__PURE__*/React.createElement(ProjectIndexListGroup, {
        count: executedAgreement.length,
        classes: "bg-success",
        status: "executed_agreement",
        title: "Executed Agreement",
        sFetching: isFetching,
        isFetchingKey: isFetchingKey,
        setCurrentActiveKey: this.setCurrentActiveKey
      }, this.renderGroup(executedAgreement)), /*#__PURE__*/React.createElement(ProjectIndexListGroup, {
        count: workStarted.length,
        classes: "bg-success",
        status: "work_started",
        title: "Work Started",
        isFetching: isFetching,
        isFetchingKey: isFetchingKey,
        setCurrentActiveKey: this.setCurrentActiveKey
      }, this.renderGroup(workStarted)), /*#__PURE__*/React.createElement(ProjectIndexListGroup, {
        count: workCompleted.length,
        classes: "bg-success",
        status: "work_completed",
        title: "Work Completed",
        isFetching: isFetching,
        isFetchingKey: isFetchingKey,
        setCurrentActiveKey: this.setCurrentActiveKey
      }, this.renderGroup(workCompleted)), /*#__PURE__*/React.createElement(ProjectIndexListGroup, {
        count: onHold.length,
        classes: "bg-warning",
        status: "on_hold",
        title: "On Hold",
        isFetching: isFetching,
        isFetchingKey: isFetchingKey,
        setCurrentActiveKey: this.setCurrentActiveKey
      }, this.renderGroup(onHold)), /*#__PURE__*/React.createElement(ProjectIndexListGroup, {
        count: closed.length,
        classes: "bg-danger",
        status: "closed",
        title: "Closed",
        isFetching: isFetching,
        isFetchingKey: isFetchingKey,
        setCurrentActiveKey: this.setCurrentActiveKey
      }, this.renderGroup(closed)), /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: this.closeModal
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement(Modal.Title, null, "Errors")), /*#__PURE__*/React.createElement(Modal.Body, null, errors.map(function (error) {
        return /*#__PURE__*/React.createElement("h4", null, error);
      })), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.closeModal
      }, "Ok"))));
    }
  }]);
}(Component);
ProjectIndexContainer.propTypes = {
  projects: PropTypes.shape({
    employer_draft: PropTypes.arrayOf(PropTypes.shape({})),
    employer_requested_matching: PropTypes.arrayOf(PropTypes.shape({})),
    clora_matching: PropTypes.arrayOf(PropTypes.shape({})),
    clora_matched: PropTypes.arrayOf(PropTypes.shape({})),
    executed_agreement: PropTypes.arrayOf(PropTypes.shape({})),
    work_started: PropTypes.arrayOf(PropTypes.shape({})),
    work_completed: PropTypes.arrayOf(PropTypes.shape({})),
    on_hold: PropTypes.arrayOf(PropTypes.shape({})),
    closed: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  csrfToken: PropTypes.string.isRequired
};
export default ProjectIndexContainer;